import { INTERVAL_OPTIONS, MetricOption } from 'pages/AnalyticsV2/types';
export enum CHART_CONFIGURATION_TYPES {
  RECOMMENDED = 'recommended',
  DO_IT_YOURSELF = 'diy',
}

export enum VISUALIZER_OPTIONS {
  BAR = 'bar',
  TABLE = 'table',
  LINE = 'line',
  UNSUPORTED = 'unsupported',
}
// export const METRIC_OPTIONS: MetricOption[] = [
//   {
//     key: 'experience-total-reach',
//     name: 'Experience total reach',
//     value: {
//       title: 'Experience total reach',
//       entity: 'experience',
//       metric: 'reach',
//     },
//   },
//   {
//     key: 'experience-total-impressions',
//     name: 'Experience total impressions',
//     value: {
//       title: 'Experience total impressions',
//       entity: 'experience',
//       metric: 'impression',
//     },
//   },
//   {
//     key: 'experience-total-engagement',
//     name: 'Experience total engagement',
//     value: {
//       title: 'Experience total engagement',
//       entity: 'experience',
//       metric: 'engagement',
//     },
//   },
//   {
//     key: 'push-delivered',
//     name: 'Push delivered',
//     value: {
//       title: 'Push delivered',
//       entity: 'push',
//       metric: 'delivered',
//     },
//   },
//   {
//     key: 'push-opened',
//     name: 'Push opened',
//     value: {
//       title: 'Push opened',
//       entity: 'push',
//       metric: 'opened',
//     },
//   },
//   {
//     key: 'content-total-viewed',
//     name: 'Content total viewed',
//     value: {
//       title: 'Content total viewed',
//       entity: 'content',
//       metric: 'viewed',
//     },
//   },
//   {
//     key: 'content-total-clicked',
//     name: 'Content total clicked',
//     value: {
//       title: 'Content total clicked',
//       entity: 'content',
//       metric: 'clicked',
//     },
//   },
//   {
//     key: 'content-unique-viewed',
//     name: 'Content unique viewed',
//     value: {
//       title: 'Content unique viewed',
//       entity: 'content',
//       metric: 'uniq-viewed',
//     },
//   },
//   {
//     key: 'content-unique-clicked',
//     name: 'Content unique clicked',
//     value: {
//       title: 'Content unique clicked',
//       entity: 'content',
//       metric: 'uniq-clicked',
//     },
//   },
//   {
//     key: 'total-engagement-rate',
//     name: 'Total engagement rate',
//     value: {
//       title: 'Total engagement rate',
//       entity: 'experience',
//       metric: 'engagement-rate',
//     },
//   },
//   {
//     key: 'unique-engagement-rate',
//     name: 'Unique engagement rate',
//     value: {
//       title: 'Unique engagement rate',
//       entity: 'experience',
//       metric: 'uniq-engagement-rate',
//     },
//   },
//   {
//     key: 'average-frequency',
//     name: 'Average frequency',
//     value: {
//       title: 'Average frequency',
//       entity: 'experience',
//       metric: 'freq',
//     },
//   },
//   {
//     key: 'push-open-rate',
//     name: 'Push open rate',
//     value: {
//       title: 'Push open rate',
//       entity: 'push',
//       metric: 'opened-rate',
//     },
//   },
//   {
//     key: 'push-engagement-rate',
//     name: 'Push engagement rate',
//     value: {
//       title: 'Push engagement rate',
//       entity: 'push',
//       metric: 'engagement-rate',
//     },
//   },
//   {
//     key: 'content-click-through-rate-total',
//     name: 'Content click-through rate (total)',
//     value: {
//       title: 'Content click-through rate (total)',
//       entity: 'content',
//       metric: 'click-rate',
//     },
//   },
//   {
//     key: 'content-click-through-rate-unique',
//     name: 'Content click-through rate (unique)',
//     value: {
//       title: 'Content click-through rate (unique)',
//       entity: 'content',
//       metric: 'uniq-click-rate',
//     },
//   },
// ];

export const METRIC_OPTIONS: MetricOption[] = [
  {
    key: 'push-sent',
    name: 'Push sent',
    value: {
      title: 'Push sent',
      entity: 'push',
      metric: 'sent',
    },
  },
  {
    key: 'push-fulfilled',
    name: 'Push fulfilled',
    value: {
      title: 'Push fulfilled',
      entity: 'push',
      metric: 'fulfilled',
    },
  },
  {
    key: 'push-viewed',
    name: 'Push viewed',
    value: {
      title: 'Push viewed',
      entity: 'push',
      metric: 'viewed',
    },
  },
  {
    key: 'push-engaged',
    name: 'Push engaged',
    value: {
      title: 'Push engaged',
      entity: 'push',
      metric: 'engaged',
    },
  },
  {
    key: 'push-reach',
    name: 'Push reached',
    value: {
      title: 'Push reached',
      entity: 'push',
      metric: 'reach',
    },
  },
  {
    key: 'push-bounced',
    name: 'Push bounced',
    value: {
      title: 'Push bounced',
      entity: 'push',
      metric: 'bounced',
    },
  },
  {
    key: 'content-fulfilled',
    name: 'Content fulfilled',
    value: {
      title: 'Content fulfilled',
      entity: 'content',
      metric: 'fulfilled',
    },
  },
  {
    key: 'content-viewed',
    name: 'Content viewed',
    value: {
      title: 'Content viewed',
      entity: 'content',
      metric: 'viewed',
    },
  },
  {
    key: 'content-engaged',
    name: 'Content engaged',
    value: {
      title: 'Content engaged',
      entity: 'content',
      metric: 'engaged',
    },
  },
  {
    key: 'content-reach',
    name: 'Content reached',
    value: {
      title: 'Content reached',
      entity: 'content',
      metric: 'reach',
    },
  },
];

export const TIMEFRAME_INTERVAL_OPTIONS = [
  { label: 'Hourly', value: INTERVAL_OPTIONS.HOURLY, duration: 3600 },
  { label: 'Daily', value: INTERVAL_OPTIONS.DAILY, duration: 3600 * 24 },
  { label: 'Weekly', value: INTERVAL_OPTIONS.WEEKLY, duration: 3600 * 24 * 7 },
  { label: 'Monthly', value: INTERVAL_OPTIONS.MONTHLY, duration: 3600 * 24 * 30.5 },
  { label: 'Annually', value: INTERVAL_OPTIONS.ANNUALLY, duration: 3600 * 24 * 365 },
];

export const EMAIL_METRIC_OPTIONS: MetricOption[] = [
  {
    key: 'email-sent',
    name: 'Email sent',
    value: {
      title: 'Email sent',
      entity: 'email',
      metric: 'sent',
    },
  },
  {
    key: 'email-clicked',
    name: 'Email clicked',
    value: {
      title: 'Email clicked',
      entity: 'email',
      metric: 'clicked',
    },
  },
  {
    key: 'email-opened',
    name: 'Email opened',
    value: {
      title: 'Email opened',
      entity: 'email',
      metric: 'opened',
    },
  },
  {
    key: 'email-failed',
    name: 'Email failed',
    value: {
      title: 'Email failed',
      entity: 'email',
      metric: 'failed',
    },
  },
  {
    key: 'email-delivered',
    name: 'Email delivered',
    value: {
      title: 'Email delivered',
      entity: 'email',
      metric: 'delivered',
    },
  },
  {
    key: 'email-bounced',
    name: 'Email bounced',
    value: {
      title: 'Email bounced',
      entity: 'email',
      metric: 'bounced',
    },
  },
];

export const SMS_METRIC_OPTIONS: MetricOption[] = [
  {
    key: 'sms-sent',
    name: 'SMS sent',
    value: {
      title: 'SMS sent',
      entity: 'sms',
      metric: 'sent',
    },
  },
  {
    key: 'sms-delivered',
    name: 'SMS delivered',
    value: {
      title: 'SMS delivered',
      entity: 'sms',
      metric: 'delivered',
    },
  },
  {
    key: 'sms-failed',
    name: 'SMS failed',
    value: {
      title: 'SMS failed',
      entity: 'sms',
      metric: 'failed',
    },
  },
];
